var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-calendar__header" }, [
    _c("div", { staticClass: "text-center" }, [
      _c("h2", { staticClass: "h5 u-color--primary u-no-margin" }, [
        _c("span", { staticClass: "c-calendar__current-week" }, [
          _vm._v(_vm._s(_vm.$t("weeks.current_week")) + ":"),
        ]),
        _vm._v("\n      KW " + _vm._s(_vm.kw) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "l-calendar-grid" },
      [
        _c(
          "div",
          { staticClass: "c-calendar__day c-calendar__day--has-heading" },
          [
            _c(
              "div",
              { staticClass: "c-calendar__kolonne-button" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "button button--action button--action--settings button--small",
                    attrs: {
                      to: {
                        name: "view-crew",
                        params: { date: _vm.startdate },
                      },
                      title: _vm.$t("weeks.kolonne.edit"),
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("weeks.kolonne.edit")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("h2", { staticClass: "c-calendar__heading" }, [
              _vm._v(_vm._s(_vm.$t("tours.kolonne"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm._l(this.days_of_week, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "c-calendar__day l-calendar-grid__cell",
            },
            [
              _c("strong", [_vm._v(_vm._s(_vm._f("moment")(item, "dd")))]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("moment")(item, "DD.MM.YYYY")) +
                  "\n    "
              ),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }